import {useIsCheckoutPage, useIsOrderSuccessPage} from '@aboutyou/router';
import {GuestUserState, useUser} from '@aboutyou/user';
import {useEffect} from 'react';

export const GuestCheckoutSessionRemover = () => {
  const isCheckoutPage = useIsCheckoutPage();
  const isOsp = useIsOrderSuccessPage();
  const {data, updateCache} = useUser();

  useEffect(() => {
    if (
      !isCheckoutPage &&
      !isOsp &&
      data &&
      'guestToken' in data &&
      (data as GuestUserState).guestToken
    ) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      updateCache({
        ...data,
        guestToken: undefined,
      });
    }
  }, [isCheckoutPage, isOsp]);

  return null;
};
